import React from 'react'
import { Table } from 'reactstrap'
import CustomerOrderShipmentService from 'domains/customer-order/services/shipment/customer-order-shipment-service'
import PropTypes from 'prop-types'

const propTypes = {
  shipment         : PropTypes.func,
  trackingResponse : PropTypes.object
}

const CourierDetailView = ({ shipment, trackingResponse }) => {
  const courierModel = CustomerOrderShipmentService.generateCourierModel(shipment, trackingResponse)
  return (
    <div className='mb-3'>
      <strong>Informasi Kurir</strong>
      <Table size='sm' className='mb-0'>
        <tbody className='small'>
          <tr>
            <td>Nama</td>
            <td className='text-right'>{ courierModel.name }</td>
          </tr>

          <tr>
            <td>No. HP</td>
            <td className='text-right'>{ courierModel.phone }</td>
          </tr>

          <tr>
            <td>No. Plat</td>
            <td className='text-right'>{ courierModel.licensePlate }</td>
          </tr>

        </tbody>
      </Table>
    </div>
  )
}

CourierDetailView.propTypes = propTypes

export default CourierDetailView